<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Translation</h4>
      </div>
      <div class="modal-body">
        @if (availableLanguages.length === 0) {
          <p class="text-muted">All languages already have a translation.</p>
        } @else {
          <div class="form-group mb-3">
            <label>Language</label>
            <select class="form-control" [(ngModel)]="languageId">
              @for (lang of availableLanguages; track lang.languageId) {
                <option [ngValue]="lang.languageId">{{ lang.languageIso }}</option>
              }
            </select>
          </div>
          <div class="form-group mb-3">
            <label>Title</label>
            <input class="form-control" [(ngModel)]="title" placeholder="Title" type="text">
          </div>
          <div class="form-group mb-3">
            <label>Summary</label>
            <textarea class="form-control" [(ngModel)]="summary" placeholder="Summary" rows="2"></textarea>
          </div>
          <div class="form-group mb-3">
            <label>Content</label>
            <textarea class="form-control" [(ngModel)]="content" placeholder="Content" rows="4"></textarea>
          </div>
          <div class="form-group mb-0">
            <label>Link Button Name</label>
            <input class="form-control" [(ngModel)]="linkButtonName" placeholder="Link button name" type="text">
          </div>
        }
      </div>
      <div class="modal-footer">
        <button [disabled]="isLoading" type="button" class="btn btn-secondary" (click)="modal.hide()">Cancel</button>
        @if (availableLanguages.length > 0) {
          <button [disabled]="isLoading" type="button" class="btn btn-primary" (click)="save()">
            @if (isLoading) { <span class="spinner-border spinner-border-sm me-1"></span> }
            Add
          </button>
        }
      </div>
    </div>
  </div>
</div>
